<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title text-center w-100" id="modal-basic-title">
      @if (fromDownloadReq) {
        {{ "approveDesign.reqDocument" | cxTranslate }}
      }
      @if (!fromDownloadReq) {
        {{ "approveDesign.approveDesign" | cxTranslate }}
      }
    </h4>
  </div>
  <div class="modal-body">
    @if (showErrorMessage) {
      <div
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
        >
        <strong>{{
          "configurators.approveDesign.errorMsg" | cxTranslate
        }}</strong>
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
          >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    }
    <div class="col-12">
      <h5 class="mb-3">{{ "approveDesign.selectedDesigns" | cxTranslate }}:</h5>
      @if (fromDownloadReq) {
        <!-- Multi-select from Download & Request: show only entries where showDesignDocument=true with checkmarks -->
        @for (configurator of selectedEntries; track configurator) {
          @if (showDesignDocumentMap.get(configurator.configurationUid)) {
            <div class="col-md-12">
              <img src="/images/check-blue.svg" />
              <label class="ml-4 design-entry-name">{{ configurator.configurationName }}</label>
            </div>
          }
        }
      } @else {
        <!-- Approve-design flow: show all entries normally -->
        @if (selectedEntries && selectedEntries.length > 0) {
          @for (configurator of selectedEntries; track configurator) {
            <div class="col-md-12">
              <img src="/images/check-blue.svg" />
              <label class="ml-4 design-entry-name">{{ configurator.configurationName }}</label>
            </div>
          }
        }
      }
      @if (!fromDownloadReq) {
        <p class="mt-2">
          {{ "approveDesign.confirmation" | cxTranslate }}
          <strong>
            {{ "approveDesign.noEdits" | cxTranslate }}
          </strong>
        </p>
      }
      <p class="mt-2">
        {{ "approveDesign.postConfirmation" | cxTranslate }}
      </p>
      <p class="mt-2">
        {{ "approveDesign.postConfirmation2" | cxTranslate }}
      </p>
      @if (!fromDownloadReq) {
        <h5 class="mt-5">
          {{ "approveDesign.sloanCustomerCareCenter" | cxTranslate }}
        </h5>
        <label>{{ "approveDesign.phone" | cxTranslate }}</label>
        <p>{{ phoneNumber }}</p>
        <label>{{ "approveDesign.email" | cxTranslate }}</label>
        <p>
          <a style="text-decoration: underline;">{{ email }}</a>
        </p>
        <label>{{ "approveDesign.hours" | cxTranslate }}</label>
        <p>
          {{ workingDays }} <br />
          {{ "approveDesign.time" | cxTranslate }}
        </p>
      }
      <!-- Warning box: entries where design documents are NOT available (fromDownloadReq only) -->
      @if (fromDownloadReq) {
        @if (unavailableDesignEntries && unavailableDesignEntries.length > 0) {
          <div class="warning-box mt-3">
            <span class="warning-icon">&#9888;&#65039;</span>
            <div class="warning-content">
              <p class="warning-text">
                {{ "downloadAndReqDocuments.designDocumentsUnavailable2" | cxTranslate }}
              </p>
              <ul class="warning-list">
                @for (entry of unavailableDesignEntries; track entry) {
                  <li><span class="cross">&#10007;</span> {{ entry.configurationName }}</li>
                }
              </ul>
            </div>
          </div>
        }
      }
    </div>
    <div class="modal-footer col-12 pt-4 mt-3 float-left">
      <button
        type="button"
        class="btn btn-default float-left"
        (click)="closeModal()"
        >
        {{ "approveDesign.cancel" | cxTranslate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary float-right"
        (click)="approveDesign()"
        >
        {{ "approveDesign.confirm" | cxTranslate }}
      </button>
    </div>
  </div>
</div>
